export default[
    {
        path: '/boletins/cartaoponto/cadastro',
        name: 'cadastro', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/boletins/cartaoponto/lista',
        name: 'lista', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/boletins/cartaoponto/editar/:id',
        name: 'lista', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]